export default __webpack_public_path__ + "static/media/2004.f8bf8d40.webp";